import { I18n } from 'react-redux-i18n-lite';
import { CMI5 } from '../../../const';

// The pie labels end with a colon ("Superado:"); the sheet rows show them on their own
const pieLabel = key => I18n.t(`gradebook.pie.${key}`).replace(/:\s*$/, '');

// Grade cell icon (same names GradeStudentRow and GradesTasksStudentRow paint) -> colour class and text
const STATUSES = {
  'check-icon': { color: 'complete', label: () => pieLabel('success') },
  'close-button': { color: 'wrong', label: () => pieLabel('failed') },
  'help-button': { color: 'pending', label: () => pieLabel('pending') },
  progress: { color: 'in-progress', label: () => pieLabel('initialized') },
  'dots-icon': { color: 'uncomplete', label: () => pieLabel('uncompleted') },
  'no-evaluable': { color: 'uncomplete', label: () => I18n.t('gradebook.noAssessable') },
  'no-eye-view': { color: 'uncomplete', label: () => I18n.t('gradebook.hiddenActivity') },
  unassign: { color: 'uncomplete', label: () => I18n.t('gradebook.mobile.notAssigned') }
};

const CONTENT_LEGEND = [
  'check-icon',
  'close-button',
  'help-button',
  'progress',
  'dots-icon',
  'no-evaluable',
  'no-eye-view',
  'unassign'
];
const TASKS_LEGEND = ['help-button', 'dots-icon', 'no-eye-view'];

export const getStatusLabel = icon => (STATUSES[icon] ? STATUSES[icon].label() : '');

export const getLegend = isTasks =>
  (isTasks ? TASKS_LEGEND : CONTENT_LEGEND).map(icon => ({
    icon,
    color: STATUSES[icon].color,
    label: getStatusLabel(icon)
  }));

// Book, unit and lesson names come as a string or as a { locale: name } object
export const getItemName = item => {
  if (!item || !item.name) {
    return '';
  }
  return typeof item.name === 'object' ? Object.values(item.name)[0] : item.name;
};

// Lessons without activities are left out of the selectors, as GradebookSelect.isAssessable
export const isSelectable = item => !(item && item.activityType === CMI5.ACTIVITY_TYPE.LESSON) || item.hasChildren;

// Id the selectors compare with, as GradebookSelect.setSelectedKey
export const getSelectionKey = item => (item ? item.id || item.activityId : undefined);

// Changing level from a student sheet reloads the grades, which unmounts the rows and their sheet. The sheet
// is kept here so the same student's row opens it again on the new level, sliding in from that direction.
const KEPT_SHEET_MS = 15000;
let keptSheet = null;

export const keepSheetOpen = (studentId, direction) => {
  keptSheet = { studentId, direction, at: Date.now() };
};

// 'down' or 'up' when this student's sheet has to open again, undefined otherwise
export const takeKeptSheet = studentId => {
  if (!keptSheet || keptSheet.studentId !== studentId) return undefined;
  const { direction, at } = keptSheet;
  keptSheet = null;
  return Date.now() - at < KEPT_SHEET_MS ? direction : undefined;
};
